<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon('fa/light/file-download')"
      icon="fa/light/file-download"
      :date="reaction.relativeDate" />

    <XCard>
      <a
        slot="header"
        :href="reaction.data.url"
        target="_blank">
        <img
          :src="reaction.data.thumbnail"
          alt="File">
      </a>
    </XCard>
  </div>
</template>

<script>
import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ]
}
</script>
